import api from "./utils";

export async function inviteUser(payload) {
  const { data } = await api.post("/admin/users/invite", payload);
  return data;
}

export async function listOrgUsers() {
  const { data } = await api.get("/admin/users");
  return data;
}

export async function updateOrgUser(userId, payload) {
  const { data } = await api.patch(`/admin/users/${userId}`, payload);
  return data;
}

export async function deleteOrgUser(userId) {
  const { data } = await api.delete(`/admin/users/${userId}`);
  return data;
}

export async function resetUserPasswordEmail(userId) {
  const { data } = await api.post(`/admin/users/${userId}/reset-password-email`);
  return data;
}

export async function getExternalTasks() {
  const { data } = await api.get("/settings/external/task");
  return data;
}

export async function configureExternalTask(task) {
  const { data } = await api.post("/settings/external/task", task);
  return data;
}

export async function getCorrelationsTasks() {
  const { data } = await api.get("/settings/correlations/task");
  return data;
}

export async function configureCorrelationsTask(task) {
  const { data } = await api.post("/settings/correlations/task", task);
  return data;
}

export async function getMispSettings() {
  const { data } = await api.get("/settings/misp");
  return data;
}

export async function setMispKey(misp_key) {
  const { data } = await api.put("/settings/misp", { misp_key });
  return data;
}

export async function deleteMispKey() {
  const { data } = await api.delete("/settings/misp");
  return data;
}
